import React, { useEffect, useState } from "react";
import Skycons, { SkyconsType } from "react-skycons";
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";
import Loader from "../common/Loader";

const getSkyconType = (code) => {
	if (code === 800) return SkyconsType.CLEAR_DAY;
	if (code === 801 || code === 802) return SkyconsType.PARTLY_CLOUDY_DAY;
	if ((code >= 200 && code <= 299) || (code >= 500 && code <= 599)) return SkyconsType.RAIN;
	if (code >= 600 && code <= 699) return SkyconsType.SNOW;
	return SkyconsType.CLOUDY;
};

const WeatherIcon = ({ code, size }) => (
	<Skycons
		color="#367d2f"
		type={getSkyconType(code)}
		animate
		size={size}
		resizeClear={false}
	/>
);

const Weather = () => {
	const [weather, setWeather] = useState(null);
	const [isUnavailable, setIsUnavailable] = useState(false);

	useEffect(() => {
		const controller = new AbortController();

		api.get("/home/weather", { signal: controller.signal })
			.then((response) => {
				setWeather(response.data);
				setIsUnavailable(false);
			})
			.catch((error) => {
				if (error.name !== "CanceledError") {
					setIsUnavailable(true);
					toast.error("Third-party weather service unavailable");
				}
			});

		return () => controller.abort();
	}, []);

	const forecast = weather ? [weather.day1, weather.day2, weather.day3] : [];

	return (
		<section className="x_panel weather-panel" aria-labelledby="weather-title">
			<header className="x_title weather-panel__header">
				<div>
					<p className="eyebrow">MILANO</p>
					<h2 id="weather-title">Today&apos;s weather</h2>
				</div>
				{weather?.observation_epoch && <time>{weather.observation_epoch}</time>}
			</header>

			<div className="x_content weather-panel__content">
				{isUnavailable ? (
					<div className="panel-empty">
						<strong>Weather data unavailable</strong>
						<span>The forecast service is temporarily unavailable.</span>
					</div>
				) : !weather ? (
					<div className="weather-panel__loading"><Loader size={26} /><span>Loading forecast</span></div>
				) : (
					<>
						<div className="weather-current">
							<div className="weather-current__icon">
								<WeatherIcon code={weather.today?.state} size={78} />
							</div>
							<div className="weather-current__value">
								<strong>{weather.temp_c ?? "NA"}<span>°C</span></strong>
								<p>Current conditions</p>
							</div>
							<div className="weather-current__humidity">
								<span>Humidity</span>
								<strong>{weather.relative_humidity ?? "NA"}%</strong>
							</div>
						</div>

						<div className="weather-forecast" aria-label="Three-day forecast">
							{forecast.map((day, index) => (
								<div className="weather-day" key={`${day?.day || "day"}-${index}`}>
									<span>{day?.day || "NA"}</span>
									<WeatherIcon code={day?.state} size={36} />
									<strong>{day?.highC ?? "NA"}°</strong>
									<small>{day?.lowC ?? "NA"}°</small>
								</div>
							))}
						</div>
					</>
				)}
			</div>
		</section>
	);
};

export default Weather;
